export enum Colors {
  EB_GREEN = 'var(--accent-base)',
  EB_RED = 'var(--pink-base)',
  AMBIENT = 'var(--ambient-base)',
  BLACK = '',
}
